import { css } from "@linaria/core";
import Button from "@ui/Button";
import formatDate from "@ui/i18n/formatDate";
import { FileInfoLine } from "@ui/IconV2/react";
import { colors, fonts, spacings } from "@ui/Theme";
import React from "react";
import t from "../../../../../../../../i18n";
import { millisecondsToFractional } from "../../../../../utils/millisecondsToFractional";

interface ResumeCardProps {
  duration: {
    startsAt: Date;
    endsAt: Date | null;
    timeZone: string;
  };
  faultNames: string[];
  historyCount?: number;
  onClick?: () => void;
  onClickHistory?: () => void;
}

const ResumeCard = ({
  duration: { startsAt, endsAt, timeZone },
  faultNames,
  historyCount,
  onClick,
  onClickHistory,
}: ResumeCardProps) => {
  const formatStartsAt = formatDate(startsAt, "slash", timeZone);
  const formatEndsAt = endsAt ? formatDate(endsAt, "slash", timeZone) : null;
  const formattedDuration = endsAt ? calculateDuration("duration", startsAt, endsAt) : null;

  return (
    <div className={resumeCard}>
      <div className={title}>
        <span className={titleName}>
          <FileInfoLine color={colors.carbon800} />
          <p>{t("project.event.header.card.resume.title.text")}</p>
        </span>
        <Button variant="link" disabled={onClick === undefined} onClick={onClick}>
          {t("project.event.header.card.resume.see_more.text")}
        </Button>
      </div>
      <div className={content}>
        <p>
          {t(
            "project.event.header.card.resume.duration.text",
            <strong>{formattedDuration}</strong>,
            formatStartsAt,
            formatEndsAt,
          )}
        </p>
        <p>
          {t(
            "project.event.header.card.resume.fault.text",
            <strong>{faultNames.join(", ")}</strong>,
            faultNames.length,
          )}
        </p>
        {historyCount !== undefined && (
          <p>
            {t("project.event.header.card.resume.history.label")}{" "}
            {onClickHistory ? (
              <Button variant="link" onClick={onClickHistory}>
                {t("project.event.header.card.resume.history.link", historyCount)}
              </Button>
            ) : (
              t("project.event.header.card.resume.history.link", historyCount)
            )}
          </p>
        )}
      </div>
    </div>
  );
};

export default ResumeCard;

//#region function
const calculateDuration = (type: "date" | "duration", startDate: Date, endDate: Date) => {
  const durationInMs = endDate.getTime() - startDate.getTime();
  const fractionalDuration = millisecondsToFractional(durationInMs);
  const formattedDuration = t("datetime.fractional", {
    type,
    ...fractionalDuration,
  });
  return formattedDuration;
};
//#endregion function
//#region CSS
const resumeCard = css``;
const title = css`
  display: flex;
  align-items: center;
  gap: ${spacings.xs};
`;
const titleName = css`
  display: inline-flex;
  align-items: center;
  gap: ${spacings.xxs};
  color: ${colors.carbon800};
  p {
    font: ${fonts.body1SemiBold};
  }
`;
const content = css`
  display: flex;
  flex-direction: column;
  gap: ${spacings.xs};
  color: ${colors.carbon800};
  margin-top: ${spacings.m};

  strong {
    font: ${fonts.body1SemiBold};
    color: ${colors.carbon900};
  }
`;
//#endregion CSS
